import useTheme from '../../utilities/hooks/theme';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetSigninModes,
  setIsLogin,
  setIsSignUp,
  setUserLoginModal,
  setUserName,
  signInWithMobile,
  updateUserPassword
} from '../../actions/user-actions-types';
import { isSmartPhone, randomUserName } from '../../utilities/helper';
import { showToast } from '../../actions/app-actions-types';
import LoginSignUpModalWeb from './index_web';
import LoginSignUpModalMWeb from './index_mWeb';

interface Props {
  visible: boolean;
  onPressClose: any;
}

const LoginSignUpModal = ({ visible, onPressClose }: Props) => {
  const {
    isLogin = false,
    isSignUp = false,
    isMobileLogin = false
  } = useSelector((state: any) => state.user);
  const [isChecked, setIsChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [userName, updateUserName] = useState('');
  const [password, setUserPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOTP] = useState('');
  const [userError, setUserError] = useState(false);
  const [passwordError, setpasswordError] = useState(false);
  const [phoneNumberError, setPhoneNumberError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [otpEnabled, setotpEnabled] = useState(false);

  const dispatch = useDispatch();
  const { DashboardTheme: theme } = useTheme();

  const surfaceStyle = {
    background: theme.loginSignUpModalBg,
    boxShadow: theme.loginSingUpModalBoxShadow
  };
  const loginSignUpBtnStyle = {
    background: theme.loginSignUpBtnBg,
    boxShadow: theme.loginSignUpBtnBoxShadow
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleCheckState = () => {
    setIsChecked(!isChecked);
  };

  const loginWithOthers = () => {
    dispatch(setUserName(randomUserName()));
    dispatch(updateUserPassword('123456'));
    dispatch(showToast('Logged In Successfully'));
    dispatch(setUserLoginModal(false));
  };
  const disableBooleans = () => {
    setotpEnabled(false);
    setUserError(false);
    setpasswordError(false);
    setPhoneNumberError(false);
    setOtpError(false);
    setotpEnabled(false);
  };
  const handleLoginSignUp = () => {
    if (!userName || !password) {
      if (!userName) {
        setUserError(true);
      } else {
        setUserError(false);
      }
      if (!password) {
        setpasswordError(true);
      } else {
        setpasswordError(false);
      }

      return false;
    } else {
      dispatch(setUserName(userName));
      dispatch(updateUserPassword(password));
      dispatch(showToast('Logged In Successfully'));
      dispatch(setUserLoginModal(false));
      disableBooleans();
    }
  };

  const updatePassword = (val: any) => {
    setUserPassword(val);
  };
  const handleUserNameChange = (val: any) => {
    updateUserName(val);
  };

  const handleMobileNumberChange = (val: any) => {
    setPhoneNumber(val);
  };

  const setLoginActive = () => {
    dispatch(setIsLogin(true));
    disableBooleans();
  };
  const setSignUpActive = () => {
    dispatch(setIsSignUp(true));
    disableBooleans();
  };
  const handleCloseModal = () => {
    dispatch(setUserLoginModal(false));
    dispatch(resetSigninModes());
    disableBooleans();
  };
  const onClickMobileLogin = () => {
    dispatch(signInWithMobile(true));
  };

  const handleRequestOtp = () => {
    if (phoneNumber.split('').length < 10) {
      setPhoneNumberError(true);
    } else {
      setPhoneNumberError(false);
      setotpEnabled(true);
    }
  };
  const onChangeOTP = (otp: any) => {
    setOTP(otp);
  };

  const handleMobileLogin = () => {
    if (otp.split('').length < 6) {
      setOtpError(true);
      return false;
    } else {
      dispatch(setUserName(phoneNumber));
      dispatch(showToast('Logged In Successfully'));
      dispatch(setUserLoginModal(false));
      disableBooleans();
    }
  };
  const props = {
    onPressClose: onPressClose,
    visible: visible,
    handleCloseModal: handleCloseModal,
    surfaceStyle: surfaceStyle,
    isLogin: isLogin,
    isMobileLogin: isMobileLogin,
    isSignUp: isSignUp,
    handleUserNameChange: handleUserNameChange,
    showPassword: showPassword,
    updatePassword: updatePassword,
    handleClickShowPassword: handleClickShowPassword,
    handleMouseDownPassword: handleMouseDownPassword,
    handleMobileNumberChange: handleMobileNumberChange,
    otpEnabled: otpEnabled,
    otp: otp,
    onChangeOTP: onChangeOTP,
    passwordError: passwordError,
    userError: userError,
    otpError: otpError,
    phoneNumberError: phoneNumberError,
    isChecked: isChecked,
    handleCheckState: handleCheckState,
    onClickMobileLogin: onClickMobileLogin,
    loginSignUpBtnStyle: loginSignUpBtnStyle,
    handleLoginSignUp: handleLoginSignUp,
    handleMobileLogin: handleMobileLogin,
    handleRequestOtp: handleRequestOtp,
    loginWithOthers: loginWithOthers,
    setSignUpActive: setSignUpActive,
    setLoginActive: setLoginActive
  };
  return (
    <React.Fragment>
      {isSmartPhone ? <LoginSignUpModalMWeb {...props} /> : <LoginSignUpModalWeb {...props} />}
    </React.Fragment>
  );
};

export default LoginSignUpModal;
